import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getPortfolioOrders } from "features/Dashboard/service";
import { PAGE_SIZE } from "utils/constants";

export const useOrdersData = (portfolioId, searchValue = "") => {
  const {
    data,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["portfolioOrders", portfolioId, searchValue],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        size: PAGE_SIZE,
        search: searchValue,
      };
      const response = await getPortfolioOrders(portfolioId, params);
      return {
        data: response.data,
        currentPage: response.page,
        totalPages: response.total_pages,
        totalCount: response.total_count,
      };
    },
    getNextPageParam: (lastPage) => {
      const currentPage = Number(lastPage.currentPage);
      const totalPages = Number(lastPage.totalPages);
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
  });

  const allOrders = data?.pages?.flatMap((page) => page.data) || [];
  const latestPage = data?.pages?.[data.pages.length - 1];
  const totalPages = latestPage?.totalPages || 0;
  const totalCount = latestPage?.totalCount || 0;
  const currentPage = latestPage?.currentPage || 1;

  return {
    orders: allOrders,
    totalPages,
    totalOrders: totalCount,
    currentPage,
    isLoading: isFetching,
    isFetchingNextPage,
    fetchNextPage,
    refetchOrders: refetch,
    hasNextPage,
  };
};
